import { Component, Input, OnInit,
	ChangeDetectorRef,ViewRef, 
    ViewChild, SimpleChanges } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { CourrierService, DialogService, StateService, DossierService } from '../../../../../services'
import { ConfirmComponent } from "../../../../partials/layout/dialogs/confirm-dialog/confirm.component"
import { CourrierDialog } from '../../../../partials/layout/dialogs/courrier-dialog/courrier-dialog.component'
import { LoadDialogComponent } from '../../../../partials/layout/dialogs/load-dialog/load.component'
import { SuiviListing } from '../../../../partials/content/listing/suivi-listing/suivi-listing.component'
import { FormulaireSuiviListing } from '../../../../partials/content/listing/formulaire-suivi-listing/formulaire-suivi-listing.component'
import { InstructionListing } from '../../../../partials/content/listing/instruction-listing/instruction-listing.component'
import { of,Observable, Subject,  } from 'rxjs'
import { MatTabChangeEvent, MatTabGroup, MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material'
import { FlatTreeControl } from '@angular/cdk/tree'
import { DatePipe } from '@angular/common'

const KEY = "dossier-page-courrier"

interface treeNode {
    id: string,
    name: string,
    children?: any[],
    type?: string,
    value?: any,
    datedebut?: string,
    disabled?: boolean,
	couleur?:string,
	icone?:string,
}

interface flatNode {
    expandable: boolean;
    name: string;
    level: number;
    id: string;
    type?: string,
    value?: any,
    datedebut?: string,
    disabled?: boolean,
	couleur?:string,
	icone?:string,
}

@Component({
    selector: 'atyl-dossier-page-courrier',
    templateUrl: './dossier-page-courrier.component.html',
    styleUrls: ['./dossier-page-courrier.component.scss']
})
@Stringable({
    path: "views/pages/recherche/tabs/courrier",
    key: KEY,
})
export class DossierPageCourrierComponent implements OnInit {
    @StringableValues(KEY) strings: any
    @Input() courriers: any[] = [];
    @Input() loading: boolean = false;

	@Input() eventLoad: Observable<boolean>;
	@Input() communication:boolean=false;

	@Input() dossier: any;
   
    @Input() user: any;
	loadListCourrier:any;

    selectedTab: number = 0;
    orderTypes : Array<["type" | "date", "desc" | "asc"]> = [["date", "desc"],["type", "asc"]];
    codeDroitVoirCourrierSuppr: string = "VOIR_COURRIER_SUPPR";
    @ViewChild('matTabGroup', { static: false }) matTabGroup: MatTabGroup;

    private _transformer = (node: treeNode, level: number) => {
        return {
            expandable: !!node.children && node.children.length > 0,
            name: node.name,
            value: node.value,
            level: level,
            id: node.id,
            disabled: node.disabled || false,
		    couleur:node.couleur,
		    icone:node.icone
        };
    }
    
    treeControl = new FlatTreeControl<flatNode>(
        node => node.level, node => node.expandable);
    treeFlattener = new MatTreeFlattener(
        this._transformer, node => node.level, node => node.expandable, node => node.children);
    dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    constructor(
        private courrierService: CourrierService,
        private stateService: StateService,
        private dialogService: DialogService,
		private changeDetectorRef: ChangeDetectorRef,
        private datePipe: DatePipe,
		private dossierService: DossierService
    ) { }
    
    ngOnInit() {
        this.stateService.dossier.subscribe((dossier: any) => {
            if (dossier) {
                this.dossier = dossier

                /*this.dossierService.getCourrierList(dossier.ID).subscribe((res: JSONRpcResponse) => {
                    const courrierRights = this._setObjectUserRights(res.result,"courrier")
                    this.courriers = courrierRights

                    this.setContainer("date", "desc")
                    this.loading = false
                    this.detectChanges()
                })
				*/
            }
        })
		
		if (this.eventLoad!=undefined) {
			this.eventLoad.subscribe((loading:boolean) => {
				this.loading=loading;
				         
				this.loadListCourrier=this.dossierService.getCourrierList(this.dossier.ID).subscribe((res: JSONRpcResponse) => {
				    this.courriers = this._setObjectUserRights(res.result,"courrier")
                    this.setContainer("date", "desc")
					
                    this.loading = false
				    this.detectChanges()
			    })         
			});
		}

        if (this.courriers) {
            this.setContainer("date", "desc")
        }
    }

    
    ngOnChanges(changes: SimpleChanges) {
       // console.log("changes",changes)
        if (changes['courriers']) {
            if(this.courriers && this.courriers.length>0){
                const [orderType, orderBy] = this.orderTypes[0]
                this.setContainer(orderType, orderBy);
                setTimeout(() => {
                    if (this.matTabGroup && this.matTabGroup.realignInkBar) {
                        this.matTabGroup.realignInkBar();
                    }
                });
            }
        }
    }
	
	ngOnDestroy() {
		if (this.loadListCourrier!=undefined)
			this.loadListCourrier.unsubscribe();
		
	
	}
	
	_setObjectUserRights(obj: any | any[], type: string) {
	       if (Array.isArray(obj)) {
	           obj.forEach((item: any) => {
	               item = this._applyRightsObj(item, type);
	           });
	       } else {
	           obj = this._applyRightsObj(obj, type);
	       }
	       return obj;
	   }
	
	 _applyRightsObj(obj: any, type: string) {
	          let rg: any = {
	              r: true,
	              w: true,
	              x: true
	          };
	          let key = null;
	          switch (type) {
	              case "visite":
	   			if (obj.consultation!=undefined && obj.consultation.type!=undefined )
	                  	key = obj.consultation.type.key;
	                  type="consultation";
	                  break;
	              case "formulaire":
	                  if (obj.form!=undefined  )
	                  	key = obj.form.key;
	                  break;
	              case "courrier":
	   			if (obj.courrier!=undefined )
	                  	key = obj.courrier.key;
	                  break;
	              case "document":
	                if (obj.document!=undefined && obj.document.type!=undefined ) 
	                  	key = obj.document.type.key;
	                  break;
	          }
	      
	          if (this.user!=undefined && this.user.droitsObjets != undefined && this.user.droitsObjets[type] != undefined) {
	              if (this.user.droitsObjets[type][key] != undefined) {
	                  rg = this.user.droitsObjets[type][key];
	              }
	          }
	      
	          obj.rights = rg;
	      
	          if (obj.editable) {
	              obj.editable = rg.w;
	          }
			 
			  if (obj.archive!=undefined && obj.archive) {
				obj.rights =				{
					              r: false,
					              w: false,
					              x: false
					          };
			  	obj.editable = false;
			   }
			   console.log("DossierPageCourrierComponent _applyRightsObj",obj);
	          return obj;
	}   
	detectChanges() {
	        setTimeout(() => {
	            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
	                this.changeDetectorRef.detectChanges()
	            }
	        })
	    }
	
    download(url: string) {
      //  window.open(url, ' _blank')
		
		const dial=this.dialogService.open(LoadDialogComponent, {
		               data: {
		                   url: url
		               },
					   height: "95vh",
					   width: "80%",
					   minimizable: true,
					   maximizable: true,
					   draggable: true,
		           }, (res: any) => {
		               
		           })
    }


    modifierCourrier(courrier: any) {
        console.log("courrier", courrier)
        console.log("courrier.html", courrier.html)
        console.log("courrier.template", courrier.template)

        this.dialogService.open(CourrierDialog, {
            data: {
                courrier: courrier,
                dossier: this.dossier,
                demandeId: courrier.ID,
            },
            width: "80vw",
            resizable: true,
            minimizable: true,
            draggable: true,
            maximizable: true,
        }, (res) => {

        })
    }

    deleteRestoreCourrier(demandeCourrier: any, deleteEvent:boolean=false) {
		  console.log("courrier delete restore",demandeCourrier,deleteEvent);
		  if (demandeCourrier) {
            const dial=this.dialogService.open(ConfirmComponent, {
                data: {
                    libelle: (deleteEvent) ? this.strings.confirmMessages.delete : this.strings.confirmMessages.restore
                },
                draggable: true,
            }, (res: any) => {
                if (res && res === 'true') {
                    this.courrierService.setCourrierEtat(demandeCourrier.ID, (deleteEvent) ? 0 : 1 ).subscribe((forms: JSONRpcResponse) => {
                        this.stateService.courriersUpdate(true)
                    })
                }
            })
        }
		 
	}	

    restoreCourrier(event: any,demandeCourrier: any) {
		console.log("DossierPageCourrierComponent restoreCourrier",event,demandeCourrier)
        if (demandeCourrier) {
            const dialogRef =this.dialogService.open(ConfirmComponent, {
                data: {
                    libelle: this.strings.confirmMessages.restore
                },
                draggable: true,
            }, (res: any) => {
                if (res && res === 'true') {
                    this.courrierService.setCourrierRestore(demandeCourrier.ID).subscribe((forms: JSONRpcResponse) => {
                        this.stateService.courriersUpdate(true)
                    })
                }
            })
        }
    }
	
   editCourrier(event: any,demandeCourrier: any) {
	console.log("DossierPageCourrierComponent editCourrier",event,demandeCourrier)
	if (demandeCourrier) {
            
            const dialogRef = this.dialogService.open(CourrierDialog, {
            data: {
                dossier: this.dossier,       
               
                
                courrier : demandeCourrier,
                demandeId : demandeCourrier.ID
                    },
                    width: "80vw",
                    resizable: true,
                    minimizable: true,
                    draggable: true,
                    maximizable: true
                });
		
		
                dialogRef.afterClosed().subscribe(result => {
                    if(result){
                    //this.reloadDossier();
                        this.stateService.courriersUpdate(true)
                    }
                });
            
           
        }
    }
    
    deleteCourrier(demandeCourrier: any) {
        if (demandeCourrier) {
            this.dialogService.open(ConfirmComponent, {
                data: {
                    libelle: this.strings.confirmMessages.delete
                },
                draggable: true,
            }, (res: any) => {
                if (res && res === 'true') {
                    this.courrierService.setCourrierDelete(demandeCourrier.ID).subscribe((forms: JSONRpcResponse) => {
                        this.stateService.courriersUpdate(true)
                    })
                }
            })
        }
    }
    
    addSuivis(event: any, courrier: any) {
        this.dialogService.open(SuiviListing, {
            data: {
                courrier: courrier,
                dossier: this.dossier,
                strings: this.strings.suivi
            },
            draggable: false,
            resizable: false,
        }, (result: any) => {
            if (result) {
                this.stateService.formulairesUpdate(true)
            }
        })
    }
    
    listSuivis(event: any, courrier: any) {
        this.dialogService.open(FormulaireSuiviListing, {
            data: {
                courrier: courrier,
                dossier: this.dossier,
                strings: this.strings.suivi
            },
            draggable: false,
            resizable: false,
        })
    }
    
    getProcedures(event: any, courrier: any) {
        console.log("DossierPageCourrierComponent getProcedures",event,courrier)
		this.dialogService.open(InstructionListing, {
            data: {
                dossier: this.dossier,
                courrier:courrier
            },
            draggable: false,
            resizable: false,
        })
        
    }

    tabChanged(event: MatTabChangeEvent) {
        this.selectedTab = event.index
        const [orderType, orderBy] = this.orderTypes[event.index]
        this.setContainer(orderType, orderBy)
    }

    setContainer(sortType: "date" | "type" = "type", orderSort: "asc" | "desc" = "asc") {
        let group = {}
        
        if (this.courriers != undefined && this.courriers && this.courriers.length>0) {
            let courrierToShow = this.courriers;

            if(this.user && !this.user.droits.hasOwnProperty(this.codeDroitVoirCourrierSuppr)){                
                courrierToShow = this.courriers.filter(courrier => courrier.status !== 0);
            }

            courrierToShow.sort((courrierA, courrierB) => this.sortGroupByDate(courrierA, courrierB, "desc", "creationdate"));
            courrierToShow.forEach((courrier) => {
                console.log("AAAA courier",courrier)

                let formattedDate = this.datePipe.transform(courrier.creationdate, 'dd/MM/yyyy')
                // const documentType = courrier.document.type.libelle
                const documentType = courrier.courrier.libelle

                const courrierParameter = courrier.courrier.parameter
                const libelleTitle = courrier.courrier.libelle
                const treeName = sortType === "date" ? formattedDate : documentType
				
				const Icon = courrier.courrier.icone
				const Couleur = courrier.courrier.color_alfa

                const disabled = false

                const libelleGroupName = sortType === "date" ? libelleTitle : courrierParameter ? courrierParameter : libelleTitle

                let childrenValues = [];
                if (courrierParameter && sortType === "type") {
                    childrenValues.push({
                        name: libelleTitle,
                        parameter: courrierParameter,
                        date: courrier.creationdate,
                        value: courrier,
                        disabled: disabled,
						couleur:  Couleur,
						icone:  Icon,
                    })
                }

                // We check if the main category exist
                if (group[treeName]) {
                    // We check if we have a sub category if yes we find if one exist and push it in
                    if (childrenValues.length > 0) {
                        const childrenGroup = group[treeName].children

                        const toPush = childrenGroup.find(child => child.parameter === courrierParameter)

                        // If the children already exist we push it
                        if (toPush) {
                            toPush.children.push(...childrenValues)

                            toPush.children = toPush.children.sort((groupA, groupB) => this.sortGroupByDate(groupA, groupB, orderSort))

                            return true
                            // We create the children if it doesn't exist
                        } else {
                            group[treeName].children.push({
                                name: courrierParameter,
                                parameter: courrierParameter,
                                value: courrier,
                                children: childrenValues,
                                disabled: disabled,
								couleur:  Couleur,
								icone:  Icon,
                            })

                            return true
                        }
                    }

                    
                    group[treeName].children.push({
                        name: libelleTitle,
                        date: courrier.creationdate,
                        parameter: courrierParameter,
                        value: courrier,
                        disabled: disabled,
						couleur:  Couleur,
					    icone:  Icon,
                        children: []
                    })

                    group[treeName].children = group[treeName].children.sort((groupA, groupB) => this.sortGroupByDate(groupA, groupB, orderSort, "creationdate"))
                    // If dont exist we create it
                } else {
                    group[treeName] = {
                        key: formattedDate,
                        name: treeName,
                        type: documentType,
                        parameter: courrierParameter,
                        date: courrier.creationdate,
                        disabled: disabled,
						couleur:  Couleur,
						icone:  Icon,
                        children: [{
                            parameter: courrierParameter,
                            name: libelleGroupName,
                            value: courrier,
                            children: childrenValues.length > 0 ? childrenValues : null,
                            disabled: disabled,
							couleur:  Couleur,
							icone:  Icon,
                        }]
                    }
                }
            });

            // We sort the list
            if (sortType === "date") {
                group = Object.values(group).sort((groupA, groupB) => this.sortGroupByDate(groupA, groupB, orderSort, "creationdate"))
            } else if (sortType === "type") {
                group = Object.values(group).sort((groupA, groupB) => this.sortGroupByType(groupA, groupB, orderSort));
            }
			console.log("DossierPageCourrierComponent group",group)
            this.dataSource.data = Object.values(group)
            this.treeControl.expandAll();
        } else {
            this.dataSource.data = []
        }

        this.changeDetectorRef.detectChanges();
        return group
    }

    sortGroupByDate(a, b, orderSort: "asc" | "desc" = "asc", field: string = 'date') {
        const dateA = new Date(a[field])
        const dateB = new Date(b[field])
        if (dateA > dateB) return orderSort === "asc" ? 1 : -1
        if (dateA < dateB) return orderSort === "asc" ? -1 : 1
        return 0
    }

    sortGroupByType(a, b, orderSort: "asc" | "desc" = "asc") {
        if (a["name"].localeCompare(b["name"]) > 0) return orderSort === "asc" ? 1 : -1
        if (b["name"].localeCompare(a["name"])) return orderSort === "asc" ? -1 : 1
        return 0;
    }

    hasChild = (_: number, node: flatNode) => node.expandable;

	
	getTitleCalendar(rdv:any) {
		let title:string="";
		let st:string[]=[];
		if (rdv.consultation!=undefined && rdv.consultation.type!=undefined
			&& rdv.consultation.type.libelle!=undefined
		 )
		    st.push(rdv.consultation.type.libelle);
		
	    let heures:string[]=[];
		if (rdv.consultation!=undefined && rdv.consultation.dates!=undefined
			&& rdv.consultation.dates.date!=undefined
		) 
			st.push(rdv.consultation.dates.date);
			
		if (rdv.heure_debut!=undefined)
			heures.push(rdv.heure_debut);
		if (rdv.heure_fin!=undefined)
			heures.push(rdv.heure_fin);
		
		if (heures.length>0)
				st.push(heures.join(" - "));
		title=st.join("\n");		
		return title;
		
	}
	
	loadMesssage(event: any,courrier:any) {
		
		console.log("DossierPageCourrierComponent loadMesssage",event,courrier);
		
		courrier.isLoadedMessage=(event.points!=undefined && event.points.length>0 );
	}
	
	menuOpened(event: any,courrier:any) {
		console.log("DossierPageCourrierComponent menuOpened",event,courrier);
		
		           courrier.isLoadedMessage=true
	}
	
    // uploadeDialog(courrier: any, editable = true) {
    //     this.dialogService.open(ChoiceCourrierComponent, {
    //         data: {
    //             courrier: courrier,
    //             slider: {
    //                 enabled: true,
    //                 dossier: this.dossier,
    //                 components: {
    //                     formulaires: true,
    //                     interventions: true,
    //                 }

    //             }
    //         },
    //         width: "40vw",
    //         minimizable: true,
    //         maximizable: true,
    //         draggable: false,
    //     }, (result: any) => {
    //         if (result && result != "") {
    //             let courrier: any = {
    //                 ID: result.selectedCourrier.ID,
    //                 demandeid: result.selectedCourrier.demandeID,
    //                 courrier: result.selectedCourrier.courrier,
    //                 value: result.selectedCourrier.value,
    //                 desciption: null,
    //                 status: result.currentEtat,
    //                 parameter: result.selectedCourrier.parameter
    //             };
    //             courrier.value.parameter = result.selectedCourrier.parameter;

    //             if (result.selectedCourrier.description)
    //                 courrier.value.description = result.selectedCourrier.description.replace(/<[^>]*>/g, '');;


    //             console.log("before update", courrier);
    //             // this.courrierService.setCourrierByInstruction(
    //             //     courrier.demandeid, courrier).subscribe((res: JSONRpcResponse) => {
    //             //         this.stateService.courriersUpdate(true);
    //             //     });
    //         }
    //     });


    // }


}




